import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Button, Modal, ModalBody, ModalFooter, Select } from "@gpstrackit/react-controls";
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    deleteBillingAccount,
    getBillingAccounts,
    reset
} from './redux/slice';
const DeleteBillingAccount = (props) => {

    //Intl
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const { openModal, loading, dealerId, billingAccount, result, error, billingAccounts } = useSelector(state => state.deleteBillingAccountRedux)
    const [newBillingAccount, setNewBillingaccount] = useState(null);


    const closeModal = () => {
        setNewBillingaccount(null);
        dispatch(reset())
    }

    const applyChanges = () => {
        dispatch(deleteBillingAccount({ id: billingAccount?.id, newBillingAccountId: newBillingAccount?.id || null }));
    }

    useEffect(() => {
        if (result) {
            let title = messages['delete_billing_account_title']
            let successMessage = messages['delete_billing_account_successfully_delete']
            let errorMessage = messages['delete_billing_account_error_delete']

            if (result?.delete) {
                NotificationManager.success(successMessage, title, 3000);
                closeModal()
                props?.tableRef && props?.tableRef?.current?.getData();
            } else {
                NotificationManager.error(errorMessage, title, 3000);
                dispatch(reset({ result: null }))
            }
        }
    }, [result])

    useEffect(() => {
        if (error) {
            let title = messages['delete_billing_account_title']
            let errorMessage = messages['delete_billing_account_error_delete']
            NotificationManager.error(errorMessage, title, 3000);
            dispatch(reset({ error: false }))
        }
    }, [error])

    useEffect(() => {
        if (openModal && dealerId) {
            dispatch(getBillingAccounts({ dealerId: dealerId }))
        }

    }, [dealerId])

    return (
        <Modal
            open={openModal}
            title={`${messages['delete_billing_account_title']} (${billingAccount?.name})`}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <div style={{ margin: 10 }}>
                        <p>{messages['delete_billing_account_descrption']}</p>
                    </div>
                    {
                        billingAccount?.assignedUnitsCount > 0 &&
                        <div style={{ margin: 10 }}>
                            <p>{messages['delete_billing_account_new_billing_account_message']}</p>
                        </div>
                    }
                    {
                        billingAccount?.assignedUnitsCount > 0 &&
                        <div style={{ margin: 10 }}>
                            <Select
                                id="billingAccounts"
                                value={newBillingAccount}
                                onChange={(value) => setNewBillingaccount(value)}
                                options={billingAccounts.filter(x => x.id !== billingAccount.id) || []}
                                label={messages['delete_billing_account_new_billing_account']}
                                valueField="id"
                                textField="name"
                                placeholder={messages['delete_billing_account_new_billing_account']}
                                required={false}
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_close']}
                </Button>
                <Button
                    className="btn btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteBillingAccount;